import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconThumbDownComponent } from "./med-icon-thumb-down.component";

@NgModule({
  declarations: [
    MedIconThumbDownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconThumbDownComponent,
  ],
})
export class MedIconThumbDownModule { }
